import { css } from 'emotion';
import youtubePlayIcon from 'images/youtubePlayIcon.png';
import youtubePlayIconInBlack from 'images/youtubePlayIconInBlack.png';

export const thumbnail = css(`
	position: relative;
	background-size: cover;
	background-position: 50% 50%;
	z-index: 1;
`);

export const playIcon = css(`
	width: 100%;
	height: 100%;
	background-image: url(${youtubePlayIconInBlack});
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-color: rgba(0,0,0,.4);
	text-align: center;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
`);

export const iframeContainer = css(`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 3;
`);

export const youtube = css(`
	:lang(ar) {
		transform: scaleX(-1);
		direction:rtl;
	}
	position: relative;
	cursor: pointer;

	&:hover .${playIcon} {
		background-image: url(${youtubePlayIcon});
	}
`);
